import { CHAIN_NAMESPACES, WEB3AUTH_NETWORK } from "@web3auth/base";
import { getDefaultExternalAdapters } from "@web3auth/default-solana-adapter";
import { SolanaPrivateKeyProvider } from "@web3auth/solana-provider";
import { Web3AuthOptions } from "@web3auth/modal";

const clientId = import.meta.env.VITE_WEB_3_AUTH_CLIENT_ID;

export const chainConfig = {
  chainNamespace: CHAIN_NAMESPACES.SOLANA,
  chainId: "0x2", // Solana testnet (devnet)
  rpcTarget: "https://api.devnet.solana.com", // Solana testnet RPC URL
  displayName: "Solana Testnet",
  blockExplorerUrl: "https://explorer.solana.com?cluster=devnet",
  ticker: "SOL",
  tickerName: "Solana",
  logo: "https://cryptologos.cc/logos/solana-sol-logo.png",
};

export const mainChainConfig = {
  chainNamespace: CHAIN_NAMESPACES.SOLANA,
  chainId: "0x1", // Solana Mainnet
  rpcTarget: "https://api.mainnet-beta.solana.com", // Solana Mainnet RPC URL
  displayName: "Solana Mainnet",
  blockExplorerUrl: "https://explorer.solana.com",
  ticker: "SOL",
  tickerName: "Solana",
  logo: "https://cryptologos.cc/logos/solana-sol-logo.png",
};

const privateKeyProvider = new SolanaPrivateKeyProvider({
  config: {
    chainConfig,
  },
});

const web3AuthOptions: Web3AuthOptions = {
  chainConfig,
  clientId,
  web3AuthNetwork: WEB3AUTH_NETWORK.TESTNET,
  privateKeyProvider,
};

const adapters = getDefaultExternalAdapters({ options: web3AuthOptions });
const filtered = adapters.filter(
  (adapter) => adapter.name !== "wallet-connect-v2",
);

const web3AuthContextConfig = {
  web3AuthOptions,
  adapters: [...filtered],
};

export default web3AuthContextConfig;
